import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { TextField, Grid, Box, Fab, Container, Typography } from "@material-ui/core";
import { Send } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    alignItems:'center'

  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadiusTop: theme.spacing(2)
  },

  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  send:{
    marginTop:theme.spacing(2)
  }
  
  
}));

export const Message=()=> {
  const classes = useStyles();

  return (

    <div className={classes.root}>
  
      <Paper className={classes.paper}>
          <Typography variant='h4'>Let's Talk With Us</Typography>
        <Container>
        <Grid container spacing={3}>
          <Grid item sm={6} xs={12}>
            <Grid item xs={12}>
              <TextField
                className={classes.field}
                id="standard-basic"
                label="Name"
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField id="standard-basic" label="Email" fullWidth />
            </Grid>
            <Grid item xs={12}>
              <TextField id="standard-basic" label="Phone Number" fullWidth />
            </Grid>
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              id="standard-basic"
              label="Message"
              multiline
              rows={6}
              fullWidth
            />
          </Grid>
        </Grid>
        <Fab variant="extended" className={classes.send} size="small">
          <Send className={classes.extendedIcon} />
          Send
        </Fab>
      </Container>
      </Paper>
      
    </div>
  );
}
